var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{on:{"click":function($event){$event.preventDefault();return _vm.getData()}}},[_c('invoice',{attrs:{"invoice":_vm.$route.query,"items":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }